export default __webpack_public_path__ + "static/media/heart.fea4aed9.svg";